/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 5);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(18);
__webpack_require__(19);
__webpack_require__(20);
__webpack_require__(21);
__webpack_require__(22);
__webpack_require__(23);

__webpack_require__(24);
__webpack_require__(25);

var dialog = __webpack_require__(1);

var QBDown = __webpack_require__(26);
var myGifts = __webpack_require__(27);
var showPrize = __webpack_require__(28);
var shareGetChance = __webpack_require__(29);
var notSub = __webpack_require__(30);
var activtyEnd = __webpack_require__(31);
var userContact = __webpack_require__(32);

var answerEnd = __webpack_require__(33);
var answerNum = __webpack_require__(34);

var userInfoObj = JSON.parse(sessionStorage.getItem("userInfo"));

function mask(type, title, msg, headsrc, width, height) {
  if (type === "QBrowser") {
    console.trace();
    dialog({
      width: 550,
      height: 290,
      body: QBDown({
        title: title,
        msg: msg
      }),
      onclose: function onclose() {},
      onshow: function onshow() {
        if (msg == '请前往电脑参与') {
          $('.pcqb-QBDown-btn').hide();
        }
      }
    }).show();
  } else if (type === "myGifts") {
    dialog({
      width: 820,
      height: 400,
      body: myGifts({}),
      onclose: function onclose() {},
      onshow: function onshow() {
        setTimeout(function () {
          $("#qtips").mouseover(function () {
            $(this).css("overflow", "visible");
          });
          $(".duiRule").mouseout(function () {
            $("#qtips").css("overflow", "hidden");
          });
          $(".duiRuleQr").mouseout(function () {
            $("#qtips").css("overflow", "hidden");
          });
        }, 400);
      }
    }).show();
  } else if (type === "showPrize") {
    dialog({
      width: 550,
      height: 530,
      body: showPrize({})
    }).show();
  } else if (type === "shareGetChance") {
    dialog({
      width: 550,
      height: 290,
      body: shareGetChance({}),
      onclose: function onclose() {
        if (lottery.showNotShare) {
          mask('shareGetChance');
          lottery.showNotShare = false;
        }
      },
      onshow: function onshow() {}
    }).show();
  } else if (type === "notSub") {
    dialog({
      width: 550,
      height: 280,
      body: notSub({}),
      onclose: function onclose() {
        if (lottery.showNotShare) {
          mask('shareGetChance');
          lottery.showNotShare = false;
        }
      }
    }).show();
  } else if (type === "activtyEnd") {
    dialog({
      width: 550,
      height: 280,
      body: activtyEnd({
        title: title,
        msg: msg
      })
    }).show();
  } else if (type === "userCon") {
    dialog({
      width: 550,
      height: 485,
      body: userContact({
        title: title,
        msg: msg
      }),
      onclose: function onclose() {
        var userInfo = {
          "userName": $("#userName").val(),
          "phoneNum": $("#phoneNum").val(),
          "provinceId_m": $("#provinceId_m").val(),
          "cityId_m": $("#cityId_m").val(),
          "areaId_m": $("#areaId_m").val(),
          "detailAddr": $("#detailAddr").val(),
          "zipCode": $("#zipCode").val()
        };
        sessionStorage.setItem("userInfo", JSON.stringify(userInfo));
      },
      onshow: function onshow() {
        setTimeout(function () {
          $("#userName").val(userInfoObj["userName"]);
          $("#phoneNum").val(userInfoObj["phoneNum"]);
          $("#provinceId_m").val(userInfoObj["provinceId_m"]);
          $("#cityId_m").val(userInfoObj["cityId_m"]);
          $("#areaId_m").val(userInfoObj["areaId_m"]);
          $("#detailAddr").val(userInfoObj["detailAddr"]);
          $("#zipCode").val(userInfoObj["zipCode"]);
        }, 500);
      }
    }).show();
  } else if (type === "answerEnd") {
    dialog({
      width: 550,
      height: 280,
      body: answerEnd({
        title: title,
        msg: msg
      })
    }).show();
  } else if (type === "answerNum") {
    dialog({
      width: 550,
      height: 380,
      body: answerNum({
        headsrc: headsrc,
        title: title,
        msg: msg
      })
    }).show();
  }
}

module.exports = mask;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var csss = __webpack_require__(16);
var template = __webpack_require__(17);
module.exports = Dialog;

var default_options = {
  body: '',
  width: 380,
  height: 0,
  maskclose: true,
  onclose: null,
  onshow: null
};

var $body = $(document.body);

function Dialog(opts) {
  if (!(this instanceof Dialog)) return new Dialog(opts);
  this.opts = $.extend({}, default_options, opts);
  this._createElement();
  this._initEvents();
}

Dialog.prototype = {

  show: function show() {
    var self = this,
        opts = self.opts,
        $el = self.$el,
        $box = self.$box;
    $box.css({
      'width': opts.width,
      'margin-left': -opts.width / 2
    });
    $el.show();

    var h = opts.height > 0 ? opts.height : $box.height();
    self.$box.css({
      'height': h,
      'top': -h / 2,
      'margin-top': -h / 2
    });

    setTimeout(function () {
      self.$el.addClass('active');
    }, 0);
    opts.onshow && opts.onshow();
    return self;
  },

  close: function close() {
    var self = this,
        opts = self.opts;
    self.$el.removeClass('active');
    self.$box.hide();
    setTimeout(function () {
      self.$el.hide();
      setTimeout(function () {
        self._destroy();
      }, 500);
    }, 350);
    opts.onclose && opts.onclose();
    return self;
  },

  on: function on() {
    var self = this,
        $el = self.$el;
    $el.on.apply($el, Array.prototype.slice.call(arguments));
    return self;
  },

  find: function find(selector) {
    return this.$box.find(selector);
  },

  _destroy: function _destroy() {
    this.$el.remove();
    this.$el = null;
    this.$box = null;
  },

  _initEvents: function _initEvents() {
    var self = this;
    self.opts.maskclose && self.$el.on('click', 'div.pcqb-dialog-mask', function (e) {
      self.close();
    });
    self.$el.on('click', '.submit', function (e) {
      self.close();
      self.opts.onclose && self.opts.onclose();
    });
    self.$el.on('click', '.close', function (e) {
      self.close();
    });
  },

  _createElement: function _createElement() {
    var $el = $(template({
      body: this.opts.body
    }));
    this.$el = $el;
    this.$box = $el.find('div.dialog-wrap');
    $body.append($el);
  }

};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var guid = void 0;
var mask = __webpack_require__(0);

function request() {}
//发送请求
request.send = function (obj, cb) {
  if (!guid) {
    try {
      guid = qbsdk.getGuid(); //window.external.getGuid().split("-").join("")
    } catch (e) {}
  }
  if (qbsdk.isQB() /*api.isQB*/) {
      zUtil.ensureLogin(function () {
        obj.guid = guid;
        zHttp.send(obj, function (res) {
          if (res.ret == 10002) {
            qq.login.open();
          } else if (res.ret == 10004) {
            //todo
          } else {
            cb && cb(res);
          }
        });
      });
    }
  // else {
  //   mask("QBrowser")
  // }
};

module.exports = request;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = utils;

function utils() {}

var parseUrlParams = utils.parseUrlParams = function (str) {
  str || (str = '');
  var vars = str.split("&");
  var json = {},
      pair;

  for (var i = 0; i < vars.length; i++) {
    pair = pair.split('=');
    json[pair[0]] = decodeURIComponent(pair[1] || '');
  }
  return json;
};
var getUrlParams = utils.getUrlParams = function (key) {
  var query = window.location.search.substring(1);
  var json = parseUrlParams(query);
  utils.getUrlParams = function (k) {
    return k ? json[k] : json;
  };
  return key ? json[key] : json;
};

utils.animateScrollTo = function (cval, tval, callback) {
  var f = 30,
      dval = tval - cval;

  function __run() {
    dval = dval / 2;
    if (Math.abs(dval) > 1) {
      cval += dval;
      callback(Math.round(cval));
      setTimeout(__run, f);
    } else {
      callback(tval);
    }
  }
  __run();
};
//QQ浏览器判断
utils.isQQBrowser = function () {
  return !/Trident/i.test(navigator.userAgent) && /QQBrowser/i.test(navigator.userAgent) && window.external && window.external.getVersion ? true : false;
};
/**
 * 对日期进行格式化，
 * @param date 要格式化的日期
 * @param format 进行格式化的模式字符串
 *     支持的模式字母有：
 *     y:年,
 *     M:年中的月份(1-12),
 *     d:月份中的天(1-31),
 *     h:小时(0-23),
 *     m:分(0-59),
 *     s:秒(0-59),
 *     S:毫秒(0-999),
 *     q:季度(1-4)
 * @return String
 */
utils.dateFormat = function (date, format) {
  date = new Date(date);

  var map = {
    "M": date.getMonth() + 1, //月份
    "d": date.getDate(), //日
    "h": date.getHours(), //小时
    "m": date.getMinutes(), //分
    "s": date.getSeconds(), //秒
    "q": Math.floor((date.getMonth() + 3) / 3), //季度
    "S": date.getMilliseconds() //毫秒
  };
  format = format.replace(/([yMdhmsqS])+/g, function (all, t) {
    var v = map[t];
    if (v !== undefined) {
      if (all.length > 1) {
        v = '0' + v;
        v = v.substr(v.length - 2);
      }
      return v;
    } else if (t === 'y') {
      return (date.getFullYear() + '').substr(4 - all.length);
    }
    return all;
  });
  return format;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* iBorad
 ----------------------------------------------------------------*/
module.exports = iBorad;

function iBorad(element, options) {
  this.defaultOptions = {
    type: 'left',
    speed: 1500,
    cycle: 3600
  };
  this.options = options || {};
  this.options = $.extend({}, this.defaultOptions, this.options);

  this.$element = $(element);
}
iBorad.prototype = {
  constructor: iBorad,
  init: function init() {
    var self = this,
        boxTotalWidth = 0;

    self.$active = this.$element.find('.board-slide .box-active');
    if (self.options.type == 'left') {
      self.$element.find('.board-slide .box').each(function () {
        boxTotalWidth += $(this).outerWidth();
      });
      // self.$element.find('.board-slide').css({width: boxTotalWidth})
    }
    self.next();
    self.isCycle || self.cycle();
  },
  next: function next() {
    var self = this,
        $target = self.$active.next()
    // , curBoxWidth = self.$active.outerWidth()

    ,
        $copyBox = self.$active.clone().removeClass('box-active'),
        slideOpt,
        slideValue;

    switch (self.options.type) {
      case 'left':
        slideValue = '-' + self.$active.outerWidth() + 'px';
        slideOpt = {
          marginLeft: slideValue
        };
        break;
      case 'top':
        slideValue = '-' + self.$active.height() + 'px';
        slideOpt = {
          marginTop: slideValue
        };
        break;
      default:
        break;
    }
    self.$active.animate(slideOpt, self.options.speed, 'linear', function () {
      $copyBox.appendTo(self.$element.find('.board-slide'));
      $(this).remove();
    });
    $target.addClass('box-active');
    self.$active = $target;
  },
  cycle: function cycle() {
    var self = this;
    if (!self.isCycle) {
      self.isCycle = setInterval(function () {
        self.next();
      }, self.options.cycle);
    }
  }
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = __webpack_require__(6);
var utils = __webpack_require__(3);
var request = __webpack_require__(2);
var iBorad = __webpack_require__(4);
__webpack_require__(41);
var mask = __webpack_require__(0);
var lotteryChanceNum = $('#lotteryBtn span');
var hasMoney = void 0;

_qblog.setting({ key: 1111, tcss: true });
_qblog.wsd.click("GREATEXPECTATIONS.PV");

//AMS新集成
zHttp.baseUrl = "http://iyouxi3.vip.qq.com/ams3.0.php";
//活动地址 不带任何参数
var _pageUrl = location.protocol + '//' + location.host + location.pathname;
// 是否在进行抽奖动画,防止用户频繁点击抽奖
var inGame = false;
//是否提示分享增加抽奖机会
var showNotShare = false;
//main
var Page = qv.zero.extend(qv.zero.AbstractPage, {
  // 项目ID
  userJsonID: 272570,
  loadExtHandler: true,
  init: function init() {
    Page.superclass.init.apply(this, arguments);
    if (!navigator.userAgent.match(/Android|iPhone|iPad|iPod|webOS|BlackBerry|Windows Phone/i) && !qbsdk.isQB()) {
      mask("QBrowser", '本活动为QQ浏览器专属活动', '请使用QQ浏览器参加');
    }
  },
  initEvent: function initEvent() {
    Page.superclass.initEvent.apply(this, arguments);
    $('body').on('click', 'a[href="#"]', function (e) {
      e.preventDefault();
    });
    qq.login.bind('login', function () {});
    qq.login.bind('logout', function () {
      $('.btn_lucky').html('<span>登录获取抽奖次数</span>');
      $('.page_0 .dy').removeClass('yi').html('<a href="javascript:void(0)" onclick="lottery.sub(true)">');
      sessionStorage.removeItem("userInfo");
    });
    if (qq.login.getUin()) {
      $('.btn_lucky').html('<span >还有<i id="money">0</i>次机会</span>');
      lottery.queryTicket();
      lottery.getVideoInfo();
    }
    lottery.queryLotteryNamelist();
    var light = $('#luckyLight');
    var _flag = true;
    setInterval(function () {
      if (_flag) {
        _flag = false;
        light.addClass('active');
      } else {
        _flag = true;
        light.removeClass('active');
      }
    }, 1000);
    // lottery.getVideosInfo();
  }

});
window.page = new Page();

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var config = {
  'title': '远大前程',
  'keywords': '远大前程',
  'description': '远大前程，QQ浏览器桌面版用户专享'
};

config.layout = __webpack_require__(7);

__webpack_require__(9);

config.qbtop = [__webpack_require__(10)];

config.qbheader = [];

config.qbbody = [__webpack_require__(12), __webpack_require__(35), __webpack_require__(37)];

config.qbfooter = [__webpack_require__(39)];

module.exports = config;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(8);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

;
(function (global, document, $) {

  __webpack_require__(11);

  var COOKIE_CONFIG = {
    domain: 'tq.qq.com',
    path: '/',
    expires: 24 * 60 * 60
  };

  function isQQBrowser() {

    return !/Trident/i.test(navigator.userAgent) && /QQBrowser/i.test(navigator.userAgent) && chrome && window.external && window.external.getVersion ? true : false;
  }

  // 初始化登录&用户信息UI
  function initLoginUI(option) {

    var showAvatar = false;
    var loginUIHtml = {
      notLogin: '你好，<a href="#" class="bt_login">请登录</a>',
      isLogin: '<span class="user_nick" title="欢迎">{nick}</span><a id="header-logout" class="mod_st_logout" href="#" title="退出">退出</a>',
      isLoginIcon: '<img class="user_icon" src="{avatar}"/><span class="user_nick">{nick}</span><a id="header-logout" class="mod_st_logout" href="#" title="退出">退出</a>'
    };

    // 绑定登录事件
    var _setLogin = function _setLogin(option) {
      showAvatar = !!option.showAvatar;
      // 登录
      qq.login.bind('login', function () {
        var _uin = qv.cookie.get('_uin');
        var _nick = qv.cookie.get('_nick');
        var _avatar = qv.cookie.get('_avctar');
        // 如果cookie里有_uin，_nick等信息，更新，否则去；拉取
        if (_uin === qq.login.getUin() && _nick && _avatar) {
          _fillUserInfo(_nick, _avatar);
        } else {
          var options = {
            url: 'http://iyouxi3.vip.qq.com/ams3.0.php',
            dataType: 'jsonp',
            data: {
              _c: 'User',
              field: "uin,nickname,faceurl",
              g_tk: qq.security.getCSRFToken()
            },
            success: function success(res, textStatus, jqXHR) {
              qv.cookie.set('_uin', res.data.uin, COOKIE_CONFIG);
              qv.cookie.set('_nick', res.data.nickname, COOKIE_CONFIG);
              qv.cookie.set('_avctar', res.data.faceurl, COOKIE_CONFIG);
              _fillUserInfo(res.data.nickname, res.data.faceurl);
              if (res.data.nickname === undefined) {
                qq.login.logout();
              }
            }
          };
          $.ajax(options);
        }
      });
      // 退出登录
      qq.login.bind('logout', function () {
        pt.logout();
        qv.cookie.clear('_uin');
        qv.cookie.clear('_nick');
        qv.cookie.clear('_avctar');
        _fillUserInfo();
      });
      if (qq.login.getUin()) {
        qq.login.trigger('login');
      } else {
        _fillUserInfo();
      }
    };

    // 设置用户信息到dom
    var _fillUserInfo = function _fillUserInfo(nick, faceurl) {
      var _arHtml = [];
      var _data = {};
      if (nick) {
        _data.nick = qv.string.encodeHTML(nick);
      }
      if (faceurl) {
        _data.avatar = faceurl;
      }
      if (!qq.login.getUin()) {
        _arHtml.push(loginUIHtml.notLogin);
      } else {
        if (showAvatar) {
          _arHtml.push(qv.string.format(loginUIHtml.isLoginIcon, _data));
        } else {
          _arHtml.push(qv.string.format(loginUIHtml.isLogin, _data));
        }
      }
      $('#navUserInfo').html(_arHtml.join(''));
      if (showAvatar) {
        $('#navUserInfo .user_icon').show();
      }
      _bindEvent();
    };
    // events: 登录 | 退出登录
    var _bindEvent = function _bindEvent() {
      $('.bt_login').click(function (e) {
        e.preventDefault();
        pt.showPtui();
      });
      $('.mod_st_logout').click(function (e) {
        e.preventDefault();
        qq.login.logout();
      });
      qq.login.trigger('navrendered');
    };

    qq.login.open = function () {
      pt.showPtui();
    };
    _setLogin(option);
  }

  // 加载&初始化登录组件ptlogin
  function initPtlogin(option) {

    var ptloginParam = {
      'appid': 1600000073,
      'daid': 5,
      's_url': location.href,
      'style': 20,
      'protocol': 'https:',
      'domain': 'qq.com',
      'border_radius': 1,
      'target': 'top',
      'maskOpacity': 40
    };
    if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object' && option.qzoneDaid) {
      ptloginParam['daid'] = 5;
    }
    $.getScript('https://xui.ptlogin2.qq.com/js/ptlogin_v1.js', function () {
      pt.setParams(ptloginParam);
    });
  }

  // header初始化
  function initHeader(option) {

    // 加载&初始化登录组件ptlogin
    initPtlogin(option);
    initLoginUI(option);

    // 加载页头UI
    // var headerClass = option.isWhiteStyle ? '' : 'black';
    var $headerQBEle = $('#headerQB');
    // $('#modHeader div.mod-act-header').addClass(headerClass);

    // 非QB显示下载按钮
    if (!isQQBrowser()) {
      $headerQBEle.css('display', 'inline');
    }
    if ((typeof option === 'undefined' ? 'undefined' : _typeof(option)) === 'object') {
      $headerQBEle.attr('href', option.downloadLink || 'http://dldir1.qq.com/invc/tt/QQBrowser_Setup_Privilegecenter.exe');
      if (option.report) {
        $headerQBEle.onclick = function () {
          _qblog.tcss.click(option.report);
        };
      }
    }
  }

  initHeader({
    // 是否白色背景风格 false黑色|true白色（可选，默认false）
    // isWhiteStyle: true,
    // 用户头像是否显示（可选，默认false）
    showAvatar: true,
    // 下载QB按钮的链接 默认：特权中心QB包（可选）
    downloadLink: 'http://dldir1.qq.com/invc/tt/QQBrowser_Setup_Privilegecenter.exe',
    // 点击流数据上报（可选）
    report: 'BROWSER.EVENTS.TOPQBDOWNLOADCLICK'
  });
})(undefined, document, jQuery);

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(13);
__webpack_require__(14);

var dialog = __webpack_require__(1);
var request = __webpack_require__(2);
var utils = __webpack_require__(3);
var iBorad = __webpack_require__(4);
var mask = __webpack_require__(0);
var animationCount = 0;
try {
  var tguid = qbsdk.getServerGuid(); //window.external.getFavSyncGuid();
} catch (e) {}

function Lottery() {
  var _$ = $;
  var _that = this;
  this.hasMoney = true;
  this.inGame = false;
  this.showNotShare = false;
  this._pageUrl = location.protocol + '//' + location.host + location.pathname;
  //中奖记录滚动展示
  this.queryLotteryNamelist = function () {
    var amsConfig = zMsg.getFormData(1); //获取数据
    var rules = [];
    rules.push('<ul id="namelist">');
    for (var i in amsConfig) {
      rules.push('<li>' + amsConfig[i]['f_1'] + '&nbsp;&nbsp;&nbsp;' + amsConfig[i]['f_2'] + '</li>');
    }
    rules.push('</ul>');
    $('#namelistDiv').html(rules.join(''));
    //获奖名单
    var luckBorad = new iBorad('#luckBoard');
    var boxHtml = '';
    /* luckBoard Load */
    //获奖名单
    var list = amsConfig;
    if (amsConfig) {
      for (var k in amsConfig) {
        boxHtml += '<div class="box">' + amsConfig[k].f_1 + '&nbsp;' + amsConfig[k].f_2 + '&nbsp;;</div>';
      }
      $(boxHtml).appendTo('#luckBoard .board-slide').first().addClass('box-active');
      luckBorad.init();
    } else {
      boxHtml += '<div class="box">&nbsp;&nbsp;暂无获奖名单</div>';
      $(boxHtml).first().addClass('box-active').appendTo('#luckBoard .board-slide');
    }
  };
  //分享
  this.shareTo = function (type) {
    var _that = this;
    _qblog.wsd.click("GREATEXPECTATIONS.SHARE");
    request.send({
      'actid': 272583 //分享增加抽奖机会
    }, function (res) {
      if (res.ret === 0) {
        //分享成功
        _that.setMoney('++');
        _qblog.wsd.click("GREATEXPECTATIONS.SHARESUCCESS");
      }
    });
    var shareObj = {
      qzone: function qzone(a) {
        var b = {
          url: a.url,
          showcount: "1",
          desc: a.description || "",
          summary: a.summary || "",
          title: a.title,
          pics: a.pic || null,
          style: "203",
          width: 98,
          height: 22
        };
        var s = [];
        for (var i in b) {
          s.push(i + '=' + encodeURIComponent(b[i] || ''));
        }
        return "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?" + s.join('&');
      },
      sina: function sina(a) {
        var b = {
          title: a.description,
          frefer: a.url,
          url: a.url,
          pic: a.pic || null
        };
        var s = [];
        for (var i in b) {
          s.push(i + '=' + encodeURIComponent(b[i] || ''));
        }
        return "http://service.weibo.com/share/share.php?uid=1&" + s.join('&');
      },
      qq: function qq(a) {
        return "http://connect.qq.com/widget/shareqq/index.html?url=" + encodeURIComponent(a.url) + "&desc=" + encodeURIComponent(a.description) + "&pics=" + encodeURIComponent(a.pic) + "&summary=" + encodeURIComponent(a.description) + "&title=" + encodeURIComponent(a.title) + "&flash=&site=QB&style=100&width=98&height=22";
      }
    };
    var wording = {
      "sina": {
        url: this._pageUrl + '?fr=sina',
        pic: "http://stdl.qq.com/stdl/qb/kp/greatexpectations.jpg",
        title: "追剧有特权 一起抽好礼",
        description: "最近追《远大前程》，演员们全部演技在线！QQ浏览器还送追剧福利：有腾讯视频VIP、年度限量周边、签名照可以免费抽~"
      },
      "qq": {
        url: this._pageUrl + '?fr=qq',
        pic: "http://stdl.qq.com/stdl/qb/kp/greatexpectations.jpg",
        title: "追剧有特权 一起抽好礼",
        description: "最近追《远大前程》，演员们全部演技在线！QQ浏览器还送追剧福利：有腾讯视频VIP、年度限量周边、签名照可以免费抽~"
      },
      "qzone": {
        url: this._pageUrl + '?fr=qzone',
        pic: "http://stdl.qq.com/stdl/qb/kp/greatexpectations.jpg",
        title: "追剧有特权 一起抽好礼",
        description: "最近追《远大前程》，演员们全部演技在线！QQ浏览器还送追剧福利：有腾讯视频VIP、年度限量周边、签名照可以免费抽~",
        summary: "最近追《远大前程》，演员们全部演技在线！QQ浏览器还送追剧福利：有腾讯视频VIP、年度限量周边、签名照可以免费抽~"
      }
    };
    if (qq.login.getUin()) {
      window.open(shareObj[type](wording[type]));
    }
  };
  // 抽奖
  this.getLucky = function () {
    var _that = this;
    _qblog.wsd.click("GREATEXPECTATIONS.LUCKY");
    request.send({
      'actid': 272599
    }, function (res) {
      if (res.ret === 0) {
        if (res.data.op.count >= 1) {
          if (_that.inGame) {
            return;
          }
          request.send({
            // 抽奖id
            'actid': 272582
          }, function (res) {
            // var res = {
            //   data: {
            //     join: {
            //       level: 4
            //     },
            //     op: {
            //       cdkey: '111111111111111111',
            //       diamonds: 3,
            //       name: '一年假期',
            //       count: 0
            //     }
            //   },
            //   ret: 0
            // }
            if (res.ret === 0) {
              //展示奖品
              _that.setMoney('--', true);
              _qblog.wsd.click("GREATEXPECTATIONS.LUCKY.OK");
              var key = res.data.op.diamonds;
              var title = res.data.op.name;
              var str = '';
              str += '<div class="tit">恭喜获得 ' + title + '</div>';
              //四等奖月卡添加cdkey
              str += '<div class="gift lv' + key + '"></div>';
              // console.log(key,"=======",res.data,"----------",title)
              switch (key) {
                case 1:
                case 2:
                  str += '<div class="btn close"><a href="#" onclick="lottery.getUserContact()">填写联系方式</a>';
                  break;
                case 3:
                case 4:
                  str += '<div class="cdkey">腾讯视频兑换码:' + res.data.op.cdkey + '</div>';
                  str += '<div class="btn"><a href="http://film.qq.com/duihuan.html" class="userCon" target="_blank">立即兑换</a>';
                  break;
                case 5:
                  str += '<div class="btn"><a href="#" class="close">我知道了</a>';
                  break;
                default:
                  str += '<div class="btn"><a href="#" class="close">我知道了</a> ';
              }
              str += '</div><div class="rule"><p>奖品发放规则：</p>';
              str += '<p>● Q币会在活动结束后一个月内，统一充值到参与活动的QQ号</p>';
              str += '<p>● 视频会员、优惠券、现金券等虚拟奖品中奖后，需立即前往指定产品官方页面进行兑换</p>';
              str += '<p>● 实物奖品将在活动结束后一月内统一发货，请在中奖后立即填写有效联系方式，因用户提供的联系地址不详以致奖品回寄的情况，将不予补送；奖品图片仅供参考，一切以实物为准</p>';
              str += '</div>';
              if (res.data.join && res.data.join.level == 1) {
                //第二次抽完奖ke提示分享
                _that.showNotShare = true;
                request.send({
                  // 查询今天是否分享过
                  'actid': 272597
                }, function (res) {
                  if (res.ret === 0) {
                    //分享过
                    if (res.data.op.count >= 1) {
                      _that.showNotShare = false;
                    } else {
                      _that.showNotShare = true;
                    }
                  }
                });
                luckAnimation.StartGame(key, function () {
                  _that.setMoneyStatus();
                  if (key < 6) {
                    mask('showPrize');
                    $('.dialog-show-prize .gifts').html(str);
                  } else {
                    if (_that.showNotShare) {
                      mask('shareGetChance');
                      _that.showNotShare = false;
                    }
                  }
                });
              } else {
                _that.showNotShare = false;
                luckAnimation.StartGame(key, function () {
                  _that.setMoneyStatus();
                  if (key < 6) {
                    setTimeout(function () {
                      mask('showPrize');
                      $('.dialog-show-prize .gifts').html(str);
                    }, 1000);
                  }
                });
              }
            } else if (res.ret === 20801) {
              //没有机会啦
              // 查询今天是否分享过
              request.send({
                'actid': 272597
              }, function (res) {
                if (res.ret === 0) {
                  //分享过
                  if (res.data.op.count >= 1) {
                    mask('activtyEnd', '今日抽奖机会已到上限啦，明天再分享依然', '可获得额外机会！');
                  } else {
                    mask('shareGetChance');
                  }
                }
                _that.inGame = false;
              });
            } else if (res.ret === 10002) {
              qq.login.open();
              _that.inGame = false;
            } else if (res.ret == 10001 || res.ret == 10004) {
              mask('activtyEnd', '活动已经结束，敬请期待更多QQ浏览器特权活动！', '');
              _that.inGame = false;
            }
          });
        } else {
          mask("notSub");
        }
      }
    });
  };
  //获取订阅信息
  this.getVideoInfo = function (t) {
    //有参数t 为抽奖前判断，无则为进入页面判断~~
    // 请求接口http: //video.browser.qq.com/api/get_video_info?video_id=100323888
    //判断是否订阅国语版
    $.ajax({
      url: "http://video.browser.qq.com/api/get_video_info",
      type: 'get',
      data: {
        video_id: 100325781,
        tguid: tguid
      },
      success: function success(res) {
        //假数据
        // var res = {
        //   subscribe: "已订阅"
        // }
        if (res.subscribe) {
          //已订阅
          $('.mod-lottery .dy').addClass('yi').html('<a href="javascript:void(0)"></a>');
          _that.sub();
        } else {
          //未订阅
          $('.mod-lottery .dy').removeClass('yi').html('<a href="javascript:void(0)" onclick="lottery.sub(true)">');
        }
      }
    });
  };
  //订阅  ams
  this.sub = function (t) {
    //有t 才同步到追剧助手
    var _that = this;
    request.send({
      // 订阅增加抽奖机会
      'actid': 272585
    }, function (res) {
      if (t) {
        _that.subscribeToVideobox(100325781);
      }
      if (res.ret === 0) {
        //第一次参加订阅
        _qblog.wsd.click("GREATEXPECTATIONS.DINYUE.OK");
        _that.setMoney('++');
        _that.setMoney('++');
      }
    });
  };
  //同步到追剧助手
  this.subscribeToVideobox = function (vid) {
    // video.browser.qq.com/域下才可以
    _qblog.wsd.click("GREATEXPECTATIONS.DINYUE.CLICK");
    $('.mod-lottery .dy').addClass('yi').html('<a href="javascript:void(0)"></a>');
    var videobox_extension_id = 'fpbdfpimimonlkoapobdbldphmiplmml';

    function sendSubscribe() {
      _qblog.wsd.click("GREATEXPECTATIONS.DINYUE.CLICK");
      chrome.runtime.sendMessage(videobox_extension_id, {
        action: 'video_center_follow_pop',
        data: {
          'vid': vid,
          orgin: 'great_expectations_201804'
        }
      });
    }
    try {
      chrome.management.get(videobox_extension_id, function (res) {
        if (res) {
          if (res.enabled) {
            sendSubscribe();
          } else {
            chrome.management.setEnabled(videobox_extension_id, true, function () {
              sendSubscribe();
            });
          }
        } else {
          chrome.management.install({
            id: videobox_extension_id
          }, function (res) {
            window.setTimeout(sendSubscribe, 600);
          });
        }
      });
    } catch (e) {
      sendSubscribe();
    }
  };
  //查询中奖记录
  this.queryRecord = function () {
    if (this.inGame) return;
    request.send({
      // zeroj 查询获奖记录
      'actid': 272584
    }, function (res) {
      if (res.ret == 0) {
        var msg = res.data.op;
        // var msg = [{
        //   val: {
        //     level: 5,
        //     time: 1521966470,
        //     name: "Q币",
        //     info: "11111111111111"
        //   }
        // }]
        var str = '';
        if (msg.length !== 0) {
          str = '<li><span>中奖日期</span><span>奖品名称</span><span>奖品详情</span><span>操作</span></li>';
          for (var i = 0; i < msg.length; i++) {
            if (msg[i].val.level < 4) {
              //实物
              str += '<li><span>' + qv.date.format("Y.m.d", msg[i].val.time * 1000) + '</span><span>' + msg[i].val.name + '</span><span>实物奖品</span>';
              str += '<span><a href="javascript:;" class="userCon" onclick="lottery.getUserContact()">填写联系方式</a></span></li>';
            } else if (msg[i].val.level == 4) {
              // 月卡
              str += '<li><span>' + qv.date.format("Y.m.d", msg[i].val.time * 1000) + '</span><span>' + msg[i].val.name + '</span><span>兑换码：' + msg[i].val.info;
              str += ' <i id="qtips"> ？<span class="duiRule">';
              str += '<ul><li><p>活动规则：</p></li>\
                                              <li><p>● Q币会在活动结束后一个月内，统一充值到参与活动的QQ号</p></li>\
                                              <li><p>● 视频会员、优惠券、现金券等虚拟奖品中奖后，需立即前往指定产品官方页面进行兑换</p></li>\
                                              <li><p>● 实物奖品将在活动结束后一月内统一发货，请在中奖后立即填写有效联系方式，因用户提供的联系地址不详以致奖品回寄的情况，将不予补送；奖品图片仅供参考，一切以实物为准</p></li>\
                                          </ul>';
              str += '</span></i></span>';
              str += '<span><a href="http://film.qq.com/duihuan.html" class="userCon" target="_blank">去兑换</a></span></li>';
            } else if (msg[i].val.level == 5) {
              // qb
              str += '<li><span>' + qv.date.format("Y.m.d", msg[i].val.time * 1000) + '</span><span>' + msg[i].val.name + '</span>';
              str += '<span>虚拟奖品 <i id="qtips"> ？<span class="duiRule">';
              str += '<ul><li><p>活动规则：</p></li>\
                                              <li><p>● Q币会在活动结束后一个月内，统一充值到参与活动的QQ号</p></li>\
                                              <li><p>● 视频会员、优惠券、现金券等虚拟奖品中奖后，需立即前往指定产品官方页面进行兑换</p></li>\
                                              <li><p>● 实物奖品将在活动结束后一月内统一发货，请在中奖后立即填写有效联系方式，因用户提供的联系地址不详以致奖品回寄的情况，将不予补送；奖品图片仅供参考，一切以实物为准</p></li>\
                                          </ul>';
              str += '</span></i></span>';
              str += '<span>自动到账</span></li>';
            }
          }
        } else {
          str += '<div id="space">';
          str += '<img src="http://stdl.qq.com/stdl/qb/kp/space.png">';
          str += '<p>暂无获奖记录，快去参加活动吧</p>';
          str += '</div>';
        }

        mask('myGifts');
        $('.dialog-myGifts .giftRecord .gifts').html(str);
      } else if (res.ret == 10002) {
        qq.login.open();
      } else if (res.ret == 10001 || res.ret == 10004) {
        mask('activtyEnd', '活动已经结束，敬请期待更多QQ浏览器特权活动！', '');
      } else {
        zHttp.showResponse(res, res.actid, $.noop);
      }
    });
  };
  //查询抽奖次数
  this.queryTicket = function () {
    var _that = this;

    // 查询抽奖次数
    request.send({
      'actid': 272598
    }, function (res) {
      if (res.ret == 0) {
        var m = parseInt(res.data.op);
        if (m == 0) {
          $('.btn_lucky').addClass('zero');
        }
        _that.setMoney(m);
      }
    });
  };
  //设置抽奖次数
  this.setMoney = function (m, s) {
    var me = jQuery('#money');
    var meVal = parseInt(me.text());
    var k = 0;
    if (parseInt(m) < 0) {
      k = meVal + parseInt(m);
    } else if (m === '++') {
      k = meVal + 1;
    } else if (m === '--') {
      k = meVal - 1;
    } else if (!isNaN(m)) {
      if (m.toString().indexOf('-') >= 0 || m.toString().indexOf('+') >= 0) {
        k = meVal + parseInt(m);
      } else {
        k = m;
      }
    }
    if (k < 0) {
      k = 0;
    }
    if (+k > 0) {
      this.hasMoney = true;
    } else {
      this.hasMoney = false;
    }
    me.text(k);
    if (!s) {
      if (k == 0) {
        $('.btn_lucky').addClass('zero');
      } else {
        $('.btn_lucky').removeClass('zero');
      }
    } else {
      $('.btn_lucky').addClass('active');
    }
  };
  this.setMoneyStatus = function () {
    if ($('#money').text() == '0') {
      $('.btn_lucky').addClass('zero');
    } else {
      $('.btn_lucky').removeClass('zero');
    }
    $('.btn_lucky').removeClass('active');
  };
  this.setUserContact = function () {
    userAddress.submitUserInfo("userName", "phoneNum", "detailAddr", "zipCode", function () {
      _$(".dialog-user-contact #success-submit").fadeIn(500).fadeOut(500);
    });
  };
  this.getUserContact = function () {
    userAddress.getUserInfo(function (res) {
      $('#userCon .userInfo').html(userAddress.tempContact(res));
    });
    mask('userCon');
  };
}
window.lottery = new Lottery();

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(15);

function LuckAnimation() {
  //�齱����
  this.StartGame = function (key, cb) {
    var _that = this;
    lottery.inGame = true;
    // var keyArr = [-25,215,35,-85,155,95];//��Ӧ��ͬ�Ľ�Ʒ�ȼ��ĽǶȼ�ȥһ�㻡�ȼ���5  ������Ʒ  60/2+5 = -25
    var keyArr = [35, -25, 95, -85, 215, 155];
    var keyNum = 6;
    var tmpAng = Math.random() * (360 / keyNum - 10);
    jQuery("#luckyGift").rotate({
      angle: 0,
      animateTo: parseInt(1440 + keyArr[key - 1] + tmpAng),
      duration: 5000,
      easing: jQuery.easing.easeInOutExpo,
      callback: cb
    });
    setTimeout(function () {
      lottery.inGame = false;
    }, 6000);
  };
}

window.luckAnimation = new LuckAnimation();

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-container"><div class="dialog-mask"></div><div class="dialog-wrap"><span class="close">✕</span><div class="dialog-body"> ' +
((__t = (body)) == null ? '' : __t) +
' </div></div></div>';

}
return __p
}

/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-qb-down"><div class="qb-down prize"><p> ' +
((__t = (title)) == null ? '' : __t) +
' </p><p> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a class="downQb" id="downloadQBBtn" href="https://dldir1.qq.com/invc/tt/QQBrowser_Setup_QB10.exe" onclick="_qblog.wsd.click(\'GREATEXPECTATIONS.QBDOWN.CLICK\');">下载QQ浏览器</a></div></div></div>';

}
return __p
}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-myGifts"><div class="giftRecord prize"><div class="tit">获奖记录</div><div class="gifts"></div></div></div>';

}
return __p
}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-show-prize"><div class="gifts"></div></div>';

}
return __p
}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-share-getChance"><div class="notShare sma"><p>抽奖机会已用完，分享给好友可额外获得</p><p>1次抽奖机会哦!</p><div class="logo">分享至： <span class="QZ" onclick="lottery.shareTo(\'qzone\');"></span> <span class="WB" onclick="lottery.shareTo(\'sina\')"></span> <span class="QQ" onclick="lottery.shareTo(\'qq\')"></span></div></div></div>';

}
return __p
}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common"><div class="notSub sma"><p>请订阅后再参与抽奖，据说手气更旺！</p><div class="btn"><a href="javascript:void(0)" onclick="lottery.sub(true);" class="close closeSub">订阅并抽奖</a></div></div></div>';

}
return __p
}

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-common"><div class="outtime sma"><p> ' +
((__t = (title)) == null ? '' : __t) +
' </p><p> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a href="javascript:void(0)" class="close">我知道了</a></div></div></div>';

}
return __p
}

/***/ }),
/* 32 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-user-contact"><div id="userCon"><div class="tit">填写联系方式</div><div class="userInfo"></div><div class="sub submit" onclick="lottery.setUserContact()">确认提交</div></div><div id="success-submit">提交成功</div></div>';

}
return __p
}

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-answer-end"><div class="answer-end"><p class="body">需要把4个题答完再交卷哦~</p><div class="btn"><a href="javascript:void(0)" class="close">我知道了</a></div></div></div>';

}
return __p
}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dialog-answer-first"><div class="answer-first"><div class="answer-title"><img src="' +
((__t = (headsrc)) == null ? '' : __t) +
'"> <span class="title"> ' +
((__t = (title)) == null ? '' : __t) +
' </span></div><p class="body"> ' +
((__t = (msg)) == null ? '' : __t) +
' </p><div class="btn"><a class="goWatch close" id="goWatch" href="https://v.qq.com/x/cover/lghf54x4o1mc2ob.html?ptag=qqbrowser&ADTAG=zd-activity" target="_blank">立即去看剧</a></div></div></div>';

}
return __p
}

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(36);
var mask = __webpack_require__(0);

$(window).scroll(function () {
    if ($(this).scrollTop() > 250) {
        $("#acMoive").attr('src', 'https://v.qq.com/iframe/player.html?vid=g00267mc70f&tiny=1&auto=1');
        $(this).unbind();
    }
});

var questionNum = 1;

var questFirst = {
    id: 1,
    // num:'01',
    dry: '一、如果你外出旅游无意间发现了一个明星大八卦，你会怎么做？',
    anfirst: ' A. 拍照发朋友圈',
    ansecond: ' B. 拍照发微博',
    anthird: ' C. 拍视频发抖音',
    anfour: ' D. 拍下来放手机自己默默观赏'
};

var questSecond = {
    id: 2,
    // num:'02',
    dry: '二、一个你默默暗恋多年的人，告诉你TA喜欢别人，你会怎么办？',
    anfirst: ' A. 还是默默守护TA',
    ansecond: ' B. 开始恨TA',
    anthird: ' C. 重新换一个人喜欢',
    anfour: ' D. 向TA告白再争取一下'
};

var questThird = {
    id: 3,
    // num:'03',
    dry: '三、和好兄弟爱上同一个女人，你会怎么做？',
    anfirst: ' A. 默默退出成全',
    ansecond: ' B. 公平竞争',
    anthird: ' C. 等待时机趁虚而入',
    anfour: ' D. 转而喜欢自己兄弟'
};

var questFour = {
    id: 4,
    // num:'04',
    dry: '四、如果你的钱多到20辈子也花不完，你会做什么事？',
    anfirst: ' A. 每天享受至尊奢华的生活',
    ansecond: ' B. 归隐山林做一个闲散人',
    anthird: ' C. 为国家民族发展做贡献',
    anfour: ' D. 在微博每天发10万红包吸粉'
};

var $answer = $("input[name=answerone]");
var AQ = [];

// 上一题
$('.previous').click(function () {
    $answer.attr("checked", false);
    questionNum--;
    if (questionNum >= 1) {
        getHtml(questionNum);
    } else {
        questionNum = 1;
    }
});

// 下一题
$('.next').click(function () {
    _qblog.wsd.click("GREATEXPECTATIONS.NEXTQUEST");
    zUtil.ensureLogin(function () {
        $answer.attr("checked", false);
        questionNum++;
        if (questionNum <= 4) {
            getHtml(questionNum);
        } else {
            questionNum = 4;
        }
    });
});

// 取radio值
$('input').click(function () {
    AQ[questionNum - 1] = $('input[name="answerone"]:checked').attr('value');
});

// 提交
$('.finish').click(function () {
    _qblog.wsd.click("ACT.GREATEXPECTATIONS.FINISH");

    if (AQ[0] === undefined || AQ[1] === undefined || AQ[2] === undefined || AQ[3] === undefined) {
        mask('answerEnd');
        return;
    }

    var answerArr = [0, 0, 0, 0];
    for (var index = 0; index < 4; index++) {
        if (AQ[index] == 1) {
            answerArr[0]++;
        } else if (AQ[index] == 2) {
            answerArr[1]++;
        } else if (AQ[index] == 3) {
            answerArr[2]++;
        } else if (AQ[index] == 4) {
            answerArr[3]++;
        }
    }

    var answerNumId = getMaxId(answerArr);
    if (answerNumId == 0) {
        // 选A多
        mask('answerNum', '你在剧中的人物是：齐林（袁弘 饰）', '一看你就是务实，为人还忠厚老实的那种人</br>袁弘扮演的这个角色，你还满意吗？', 'http://stdl.qq.com/stdl/qb/kp/a.png');
    } else if (answerNumId == 1) {
        // 选B
        mask('answerNum', '你在剧中的人物是：林依依（佟丽娅 饰）', '一看你就爱憎分明！少侠有胆识，有见地，</br>佟丽娅都为你打call!', 'http://stdl.qq.com/stdl/qb/kp/b.png');
    } else if (answerNumId == 2) {
        // 选C
        mask('answerNum', '你在剧中的人物是于梦竹（郭采洁 饰）', '你是大大滴好人，心怀天下的富二代</br>郭采洁表示很赞赏你哦~', 'http://stdl.qq.com/stdl/qb/kp/c.png');
    } else {
        // 选D
        mask('answerNum', '你在剧中的人物是洪三元（陈思诚 饰）', '嘿，亲！你口味不是一般重啊~</br>连陈思诚都表示：你果然不是一般人！', 'http://stdl.qq.com/stdl/qb/kp/d.png');
    }
    // 提交后清空数值
    getHtml(1);
    $answer.removeAttr("checked");
    questionNum = 1;
    AQ = [];
    answerArr = [0, 0, 0, 0];
    answerNumId = 0;
});

// 取数组最大值的索引
function getMaxId(arr) {
    // 将数组第一个元素的值赋给max 
    var arrmax = arr[0];
    var arrnum = 0;
    // 使用for 循环从数组第一个值开始做遍历 
    for (var i = 1; i < arr.length; i++) {
        // 如果元素当前值大于max,就把这个当前值赋值给max 
        if (arr[i] > arrmax) {
            arrmax = arr[i];
            arrnum = i;
        }
    }
    // 返回最大的值的索引
    return arrnum;
}

// 改变题目
function getHtml(num) {
    if (num == 1) {
        // $('.ranswer .spanNum').html('<span>'+ questFirst.num + '</span>')
        $('.rantitle .answerNum').html(questFirst.id);
        $('.questions .question-dry').html(questFirst.dry);
        $('.questions .one .an-one').html(questFirst.anfirst);
        $('.questions .two .an-two').html(questFirst.ansecond);
        $('.questions .three .an-three').html(questFirst.anthird);
        $('.questions .four .an-four').html(questFirst.anfour);
        $("input[value=" + AQ[num - 1] + "]").attr('checked', 'true');
        $('.previous').css('display', 'none');
        $('.next').css('display', 'inline-block');
        $('.finish').css('display', 'none');
    } else if (num == 2) {
        // $('.ranswer .spanNum').html('<span>'+ questSecond.num + '</span>');
        $('.rantitle .answerNum').html(questSecond.id);
        $('.questions .question-dry').html(questSecond.dry);
        $('.questions .one .an-one').html(questSecond.anfirst);
        $('.questions .two .an-two').html(questSecond.ansecond);
        $('.questions .three .an-three').html(questSecond.anthird);
        $('.questions .four .an-four').html(questSecond.anfour);
        $("input[value=" + AQ[num - 1] + "]").attr('checked', 'true');
        $('.previous').css('display', 'inline-block');
        $('.next').css('display', 'inline-block');
        $('.finish').css('display', 'none');
    } else if (num == 3) {
        // $('.ranswer .spanNum').html('<span>'+ questThird.num + '</span>');
        $('.rantitle .answerNum').html(questThird.id);
        $('.questions .question-dry').html(questThird.dry);
        $('.questions .one .an-one').html(questThird.anfirst);
        $('.questions .two .an-two').html(questThird.ansecond);
        $('.questions .three .an-three').html(questThird.anthird);
        $('.questions .four .an-four').html(questThird.anfour);
        $("input[value=" + AQ[num - 1] + "]").attr('checked', 'true');
        $('.previous').css('display', 'inline-block');
        $('.next').css('display', 'inline-block');
        $('.finish').css('display', 'none');
    } else if (num == 4) {
        // $('.ranswer .spanNum').html('<span>'+ questFour.num + '</span>');
        $('.rantitle .answerNum').html(questFour.id);
        $('.questions .question-dry').html(questFour.dry);
        $('.questions .one .an-one').html(questFour.anfirst);
        $('.questions .two .an-two').html(questFour.ansecond);
        $('.questions .three .an-three').html(questFour.anthird);
        $('.questions .four .an-four').html(questFour.anfour);
        $("input[value=" + AQ[num - 1] + "]").attr('checked', 'true');
        $('.next').css('display', 'none');
        $('.previous').css('display', 'inline-block');
        $('.finish').css('display', 'inline-block');
    }
}

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(38);

$(document).on('click', 'a[data-vid]', function (e) {
  var vid = $(this).data('vid');
  _qblog.wsd.click('GREATEXPECTATIONS.RECOMMEND');
  _qblog.wsd.click('GREATEXPECTATIONS.' + vid);
});

// 获取视频片单信息
function getVideosInfo() {
  var vidArr = [100325571, 100324235, 100324155, 100324103, 100323686];

  var list = '';
  for (var i = 0; i < vidArr.length; i++) {
    //请求接口http://video.browser.qq.com/api/get_video_info?video_id=
    jQuery.ajax({
      url: "http://video.browser.qq.com/api/get_video_info",
      type: 'get',
      // async: false,
      data: {
        video_id: vidArr[i]
      },
      success: function success(res) {
        var dataNum = res.videoBasic.setNum[0];
        // type == 4 综艺
        if (res.videoBasic.type == 4) {
          list = '更新至' + dataNum.updateSetNum + '集';
        } else {
          if (dataNum.totalSetNum == dataNum.updateSetNum) {
            list = '全' + dataNum.totalSetNum + '集';
          } else {
            list = '更新至' + dataNum.updateSetNum + '集';
          }
        }
        $('.videos .' + res.videoBasic.videoId).html(list);
      }
    });
  }
}

getVideosInfo();

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(40);

/***/ }),
/* 40 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// 来自 http://stdl.qq.com/stdl/tq_center/activity/common/header_footer_v2.js
// 暂时使用，后面需要替换掉这个旧的

(function ($) {
  var userInfo = {};
  var isQB = isQB = isQQBrowser();

  function getUserInfo(cb) {
    zUtil.ensureLogin(function () {
      $.ajax({
        url: 'http://cgi.vip.qq.com/contact/getusercontact',
        type: "get",
        dataType: "jsonp",
        data: {
          g_tk: qq.security.getCSRFToken()
        },
        jsonp: "callback",
        success: function success(json) {
          if (json.ret === 0) {
            userInfo = {
              name: json.data.NAME,
              phone: json.data.PHONE,
              email: json.data.EMAIL,
              address: json.data.POST_ADDR
            };
            cb ? cb(userInfo) : null;
          } else if (json.ret === -7) {
            qq.login.open();
          } else {}
        }
      });
    });
  };

  function setUserInfo(obj, cb) {
    for (var i in obj) {
      obj[i] = obj[i].trim();
    }
    if (obj.name.length == 0) {
      alert('濮撳悕涓嶈兘涓虹┖锛�');
      return;
    } else if (obj.name.length < 2 || !/^[a-zA-Z\u4e00-\u9fa5]{0,}$/.test(obj.name)) {
      alert('濮撳悕涓嶅悎娉曪紝璇烽噸鏂拌緭鍏ワ紒');
      return;
    }
    if (obj.phone.length == 0) {
      alert('鎵嬫満鍙蜂笉鑳戒负绌猴紒');
      return;
    } else if (obj.phone != userInfo.phone) {
      if (isNaN(obj.phone) || obj.phone.length != 11) {
        alert('璇疯緭鍏ユ湁鏁堢殑鎵嬫満鍙凤紒');
        return;
      }
    }
    if (obj.email.length == 0) {
      alert('鐢靛瓙閭涓嶈兘涓虹┖锛�');
      return;
    } else if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(obj.email)) {
      alert('璇疯緭鍏ユ湁鏁堢殑鐢靛瓙閭锛�');
      return;
    }
    if (obj.address.length == 0) {
      alert('閭瘎鍦板潃涓嶈兘涓虹┖锛�');
      return;
    } else if (!/^[a-zA-Z0-9\u4e00-\u9fa5]{0,}$/.test(obj.address)) {
      alert('闈炴硶鐨勬眽瀛楀拰鑻辨枃瀛楃锛岃閲嶆柊杈撳叆锛�');
      return;
    }
    var _url = 'http://cgi.vip.qq.com/contact/setusercontact?name=' + obj.name + '&phone=' + obj.phone + '&email=' + obj.email + '&post_address=' + obj.address + '&noChange_phone=';
    if (obj.phone == userInfo.phone) {
      _url += "1";
    } else {
      _url += "0";
    }
    var temp = 0;
    for (var k in obj) {
      if (obj[k] == userInfo[k]) {
        temp++;
      }
    }
    if (temp == 4) {
      cb ? cb() : null;
      return;
    }
    zUtil.ensureLogin(function () {
      $.ajax({
        url: _url,
        type: "get",
        dataType: "jsonp",
        data: {
          g_tk: qq.security.getCSRFToken()
        },
        jsonp: "callback",
        success: function success(json) {
          if (json.ret == 0) {
            cb ? cb() : null;
          } else if (json.ret == -7) {
            qq.login.open();
          } else {}
        }
      });
    });
  }

  function initUserInfo(phone) {
    $('body').on('focus', '#' + phone, function () {
      if ($(this).val() == userInfo.phone) {
        $(this).val('');
      }
    });
    $('body').on('blur', '#' + phone, function () {
      if ($(this).val() == '') {
        $(this).val(userInfo.phone);
      }
    });
  }

  function submitUserInfo(name, phone, email, address, cb) {
    userContact = {
      name: $('#' + name).val(),
      phone: $('#' + phone).val(),
      email: $('#' + email).val(),
      address: $('#' + address).val()
    };
    setUserInfo(userContact, function () {
      cb ? cb() : '';
    });
  }

  function report(hottagValue) {
    window.setTimeout(function () {
      try {
        pgvSendClick({
          hottag: hottagValue
        });
      } catch (e) {}
    }, 100);
  }

  function dataReport(a, b, c, d, e, f, g, h, i) {
    window.setTimeout(function () {
      try {
        window.external.dataReport(a, b, c, d, e, f, g, h, i);
      } catch (e) {
        console.log(e);
      }
    }, 100);
  }
  window.setTimeout(function () {
    if (typeof pgvMain == 'function') {
      pgvMain("pathtrace", {
        pathStart: true,
        tagParamName: "ADTAG",
        useRefUrl: true,
        override: true,
        careSameDomainRef: false
      });
    }
  }, 1000);

  function getQBVersion() {
    var version = 0;
    try {
      try {
        version = window.external.getVersion() || 1;
      } catch (e) {
        version = window.external.getbrowserversion() || 1;
      }
    } catch (e) {
      version = /QQBrowser/.test(navigator.userAgent) || "100.0.0.0";
    }
    return version;
  }

  function isQQBrowser() {
    var version = getQBVersion();
    var result = version != "100.0.0.0" && version != 0;
    isQQBrowser = function isQQBrowser() {
      return result;
    };
    return result;
  }

  window.api = {
    setUserInfo: setUserInfo,
    getUserInfo: getUserInfo,
    initUserInfo: initUserInfo,
    submitUserInfo: submitUserInfo,
    report: report,
    dataReport: dataReport,
    getQBVersion: getQBVersion,
    isQQBrowser: isQQBrowser,
    isQB: isQB
  };
})(jQuery);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// index.js